import { WrapperEntitySelector } from '@components/Inputs';
import { Grid, Checkbox, Typography } from '@ts/storybook';

interface IQuickCreateRelatedModelProps {
  value: any;
  isReadOnly: boolean;
  label: string;
  searchComponent: any;
  onChange: (value: any) => void;
  checked: boolean;
  onCheck: (checked: boolean) => void;
}

const QuickCreateRelatedModel = (props: IQuickCreateRelatedModelProps) => {
  let checkStr = '';
  if (props.checked) {
    checkStr = 'If the introduced ID does not exist, it will be created';
  } else checkStr = 'If the introduced ID does not exist, it will NOT be created';

  return (
    <Grid container spacing={2} direction="row" alignItems="center">
      <Grid size={{ xs: 11 }}>
        <WrapperEntitySelector
          isReadOnly={props.isReadOnly}
          label={props.label}
          searchComponent={props.searchComponent}
          onChangeEntity={props.onChange}
          value={props.value}
        />
      </Grid>
      <Grid size={{ xs: 1 }}>
        <Checkbox disabled={props.isReadOnly} checked={props.checked} onChangeValue={props.onCheck} className="pt-5" />
      </Grid>
      <Grid>
        <Typography variant="body2" text={checkStr} />
      </Grid>
    </Grid>
  );
};

export default QuickCreateRelatedModel;
